module.exports = __webpack_public_path__ + "static/media/Coming soon.33a52f30.png";